import React from 'react'

/**
 * Silhueta de Blumenau — casario enxaimel com torres de igreja, o pano de
 * fundo que aparece em quase toda lâmina do kit da identidade.
 *
 * Path procedural em vez de imagem: são 600 bytes contra dezenas de KB de um
 * PNG, e como é `fill: currentColor` a cor vem do CSS de cada uso — o mesmo
 * arquivo serve o hero (mais presente) e os fundos de seção (quase
 * imperceptível) só trocando `color`/`opacity`.
 *
 * `preserveAspectRatio="none"` de propósito: isto é textura de horizonte, não
 * ilustração. Deixar esticar na largura do viewport é o comportamento
 * desejado — deformar telhado de silhueta a 8% de opacidade não é percebido,
 * e evita ter de casar a proporção do SVG com a de cada seção.
 */
const CASARIO = 'M 0,200 L 0,168 L 40,168 L 40,150 L 68,124 L 96,150 L 96,162 L 140,162 L 140,100 L 154,52 L 168,100 L 168,154 L 199,128 L 230,154 L 230,166 L 286,166 L 286,146 L 313,118 L 340,146 L 340,92 L 353,40 L 366,92 L 366,158 L 398,132 L 430,158 L 430,168 L 492,168 L 492,150 L 520,122 L 548,150 L 548,162 L 600,162 L 600,110 L 620,64 L 640,110 L 640,156 L 670,130 L 700,156 L 700,166 L 760,166 L 760,148 L 788,120 L 816,148 L 816,160 L 870,160 L 870,104 L 885,56 L 900,104 L 900,152 L 930,126 L 960,152 L 960,166 L 1020,166 L 1020,146 L 1048,118 L 1076,146 L 1076,160 L 1140,160 L 1140,168 L 1200,168 L 1200,200 Z'

export default function SilhuetaBlumenau({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 1200 200"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d={CASARIO} fill="currentColor" />
    </svg>
  )
}
